// Stimulus setup
import { Application } from "./vendor/stimulus.js";
import WPKIController from "./controllers/wpki_controller.js";
import OutletController from "./controllers/outlet_controller.js";
import OutletMultiselectController from "./controllers/outlet_multiselect_controller.js";
import TypewriterController from "./controllers/typewriter_controller.js";
import ScrollableController from "./controllers/scrollable_controller.js";
import SSEController from "./controllers/sse_controller.js";
import FileUploadController from "./controllers/file_upload_controller.js";
import SuggestionsController from "./controllers/suggestions_controller.js";
import FormOutletController from "./controllers/form_outlet_controller.js";
import AutogrowController from "./controllers/autogrow_controller.js";
import DropdownController from "./controllers/dropdown_controller.js";
import MainController from "./controllers/main_controller.js";
import MoodboardController from "./controllers/moodboard_controller.js";
import ImageSliderController from "./controllers/image_slider_controller.js";
import LazyLoadController from "./controllers/lazy_load_controller.js";
import InlineSvgController from "./controllers/inline_svg_controller.js";

const application = Application.start();
application.register("wpki", WPKIController);
application.register("outlet", OutletController);
application.register("outlet-multiselect", OutletMultiselectController);
application.register("typewriter", TypewriterController);
application.register("scrollable", ScrollableController);
application.register("sse", SSEController);
application.register("file-upload", FileUploadController);
application.register("suggestions", SuggestionsController);
application.register("form-outlet", FormOutletController);
application.register("autogrow", AutogrowController);
application.register("dropdown", DropdownController);
application.register("moodboard", MoodboardController);
application.register("main", MainController);
application.register("image-slider", ImageSliderController);
application.register("lazy-load", LazyLoadController);
application.register("inline-svg", InlineSvgController);

// expose for debugging in the console
window.Stimulus = application;

// Import modules that run on page load
